export interface SeoTokens {
  title?: string;
  description?: string;
}

/**
 * Mirrors the public `Seo` component exactly: replaces the known {title} /
 * {description} tokens with the item's real values and leaves anything else
 * untouched, so the admin preview matches what a crawler sees.
 */
export function applySeoTokens(
  template: string | null | undefined,
  tokens: SeoTokens,
): string {
  if (!template) return "";
  return template.replace(/\{(\w+)\}/g, (whole, key: string) => {
    if (key === "title" && tokens.title) return tokens.title;
    if (key === "description" && tokens.description) return tokens.description;
    return whole;
  });
}

/**
 * Preview-only variant: blanks out any leftover tokens so a raw "{description}"
 * never leaks into the snippet when an item has no summary of its own.
 */
export function resolvePreview(
  template: string | null | undefined,
  tokens: SeoTokens,
): string {
  if (!template) return "";
  return template
    .replace(/\{title\}/g, tokens.title || "")
    .replace(/\{description\}/g, tokens.description || "")
    .replace(/\s{2,}/g, " ")
    .trim();
}